import React, { createContext, useContext } from "react";
import type { StackScreenOptions } from "./stack-navigator-store";

interface StackScreenContextValue {
  key: string;
  canGoBack: boolean;
  isTopScreen: boolean;
  close: (value?: any) => void;
  setOptions: (options: Partial<StackScreenOptions>) => void;
}

export const StackScreenContext = createContext<StackScreenContextValue | null>(
  null,
);

export function useStackScreen() {
  const value = useContext(StackScreenContext);
  if (!value) {
    throw new Error("StackScreenContext is missing");
  }

  return value;
}
